// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1995":"8c773b16087a9521","2750":"05021a3ba502959d","6859":"948d6009e8151b8e","8862":"c62ec8db3cdb5da4"}[chunkId] + ".css";
};